// firebase.js - UPDATED for Firestore

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAOWwYRiIPDBFrik6QbXRclrqWUuvRp2dc",
  authDomain: "x-stitch-app.firebaseapp.com",
  projectId: "x-stitch-app",
  storageBucket: "x-stitch-app.firebasestorage.app",
  messagingSenderId: "262250690428",
  appId: "1:262250690428:web:7a4dfc9c57fc89265856f9",
  measurementId: "G-7JZDPB5QGC"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const cloudFunctions = getFunctions(app, "us-central1");
